import installationInstructions from './installationInstructions';

const niroContent = {
  installationInstructions
}

export { niroContent };